import React from 'react'

import IconEmail from 'client/icons/Email'
import IconFacebook from 'client/icons/social/Facebook'
import IconX from 'client/icons/social/X'
import IconWhatsapp from 'client/icons/social/Whatsapp'

export const SOURCES = [
  {
    name: 'whatsapp',
    label: 'share.via-whatsapp',
    icon: <IconWhatsapp />,
    url: 'https://wa.me/?text=',
  },
  {
    name: 'facebook',
    label: 'share.via-facebook',
    icon: <IconFacebook />,
    url: 'https://www.facebook.com/sharer.php?u=',
  },
  {
    name: 'twitter',
    label: 'share.on-x',
    icon: <IconX />,
    url: 'https://x.com/intent/post?url=',
  },
  {
    name: 'email',
    label: 'share.via-email',
    icon: <IconEmail />,
    url: 'mailto:?body=',
  },
]
